(() => {
  const REVIEW_LIMIT = 3;
  const LONG_REVIEW_LENGTH = 420;
  const REVIEW_TRANSLATIONS = [
    {
      title: 'Review from Monja',
      content: 'Buono',
      translatedTitle: 'Bewertung von Monja',
      translatedContent: 'Gut.',
    },
    {
      title: 'Anti-Rutsch Paw Pads',
      content: 'Halten sehr gut, wenn nicht zu viele Haare zwischen den Pfoten sind. Mein Frenchie hat jetzt wieder Grip... ;-)',
      translatedTitle: 'Anti-Rutsch-Pfotenpads',
      translatedContent: 'Halten sehr gut, wenn nicht zu viele Haare zwischen den Pfoten sind. Mein Frenchie hat jetzt wieder Grip... ;-)',
    },
    {
      title: 'Review from Shelley',
      content: "These work really good my veterinarian recommended them, although he did say to cut the sticky up and put them on the pads as they fall off if you don't. because the toes move independently of the sticky. My dog does not like them we will see how well they hold up but they do stop him from slipping.",
      translatedTitle: 'Bewertung von Shelley',
      translatedContent: 'Sie funktionieren wirklich gut; mein Tierarzt hat sie empfohlen. Er riet allerdings dazu, die Klebefläche zuzuschneiden und direkt auf die Ballen zu kleben, da sie sonst abfallen, weil sich die Zehen unabhängig von der Klebefläche bewegen. Mein Hund mag sie nicht besonders. Wir werden sehen, wie gut sie halten, aber sie verhindern auf jeden Fall, dass er ausrutscht.',
    },
    {
      title: 'Review from MarinaAzul',
      content: 'Excelente, realmente ayuda al perro a no resbalarse, y a poder levantarse mejor, teniendo problemas de movilidad debido a una lesión medular. Sí preferiría que el precio fuera algo inferior porque duran muy poco, el perro se las mordisquea y, en mi caso, hay que cambiarlas a diario. Aún así, no creo que le molesten para nada (porque él se mordisquea de todas maneras), y le ayudan muchísimo. Respecto a mi perro, que no es de pelo corto, es mejor recortar los pelitos de los deditos, antes de pegarlas, porque si no, al quitarlas, le tiran de los pelitos y le molesta. En fin, un producto muy acertado, lo volveré a comprar. Una gran idea.',
      translatedTitle: 'Bewertung von MarinaAzul',
      translatedContent: 'Ausgezeichnet, sie helfen dem Hund wirklich dabei, nicht auszurutschen und besser aufzustehen, wenn er aufgrund einer Rückenmarksverletzung Mobilitätsprobleme hat. Ich würde mir einen etwas niedrigeren Preis wünschen, weil sie nur sehr kurz halten; mein Hund knabbert daran und in meinem Fall müssen sie täglich gewechselt werden. Trotzdem glaube ich nicht, dass sie ihn stören, und sie helfen ihm sehr. Bei längerem Fell ist es besser, vor dem Aufkleben die Haare zwischen den Zehen zu kürzen, damit es beim Entfernen nicht zieht. Insgesamt ein sehr gelungenes Produkt, das ich wieder kaufen würde.',
    },
    {
      title: 'Review from Mara CB',
      content: 'Creo que lo escogí de una talla más pequeña pero no estoy segura pero se le despegaba rápido',
      translatedTitle: 'Bewertung von Mara CB',
      translatedContent: 'Ich glaube, ich habe eine zu kleine Größe gewählt, bin mir aber nicht sicher. Sie lösten sich jedenfalls schnell ab.',
    },
    {
      title: 'Review from Tasha',
      content: 'These are brilliant. My dog seems to not know he has them on. They come off when running around in wet grass which is to be expected otherwise they stay on. Life saver for dogs with grip issues',
      translatedTitle: 'Bewertung von Tasha',
      translatedContent: 'Sie sind großartig. Mein Hund scheint gar nicht zu bemerken, dass er sie trägt. Beim Herumtoben im nassen Gras lösen sie sich, was zu erwarten ist; ansonsten halten sie. Eine echte Rettung für Hunde mit Problemen beim Halt.',
    },
    {
      title: 'Review from Visi',
      content: 'Conviennent parfaitement, taille M, pour les pattes de ma Jack Russel de 16 ans qui a des problèmes de stabilité aux 2 pattes arrière.  Bonne adhérence, facile à positionner et résistent environ 2 jours. Satisfaite de mon achat !',
      translatedTitle: 'Bewertung von Visi',
      translatedContent: 'Sie passen in Größe M perfekt an die Pfoten meiner 16-jährigen Jack-Russell-Hündin, die Probleme mit der Stabilität der beiden Hinterbeine hat. Guter Halt, einfach anzubringen und sie halten etwa zwei Tage. Ich bin mit meinem Kauf zufrieden!',
    },
    {
      title: 'Review from Alex Rodriguez',
      content: 'Tenía preocupación que molestaran las patitas de mi perro o que le irritaran los cojinetes. ¡Para nada! Son super cómodos, fácil de instalar, no son molestos al poner o retirar y mi perro se pudo apoyar muchísimo mejor en el piso resbaloso de la casa. Fueron una diferencia enorme para mejorar su caminata en casa.',
      translatedTitle: 'Bewertung von Alex Rodriguez',
      translatedContent: 'Ich hatte Sorge, dass sie die Pfoten meines Hundes stören oder die Ballen reizen könnten. Überhaupt nicht! Sie sind sehr bequem, einfach anzubringen, stören weder beim Aufkleben noch beim Entfernen und mein Hund konnte sich auf dem rutschigen Boden zu Hause viel besser abstützen. Sie haben beim Gehen im Haus einen enormen Unterschied gemacht.',
    },
  ];
  const REVIEW_COPY_EDITS = [
    {
      title: 'Gute Alternative zu Hundesocken',
      content: 'Hält 1-2 Tage, aber besser wie Hundeschuhe.',
      editedTitle: 'Gute Alternative zu Hundesocken',
      editedContent: 'Hält ein bis zwei Tage und ist für uns angenehmer als Hundeschuhe.',
    },
    {
      title: 'Hilft super',
      content: 'Funktioniert super. Leider halten sie Max einen Tag aber meine hat nach zwei Tagen schon wieder deutlich du Angst verloren auf glattem Boden und lief dann auch ohne. Ich habe sie zerschnitten damit sie besser kleben',
      editedTitle: 'Hilft super',
      editedContent: 'Funktioniert super. Bei uns halten die Pads höchstens einen Tag, aber mein Hund hatte nach zwei Tagen schon deutlich weniger Angst auf glattem Boden und lief danach sogar wieder ohne. Ich habe sie zugeschnitten, damit sie besser kleben.',
    },
  ];
  let scanQueued = false;

  function normalizeReviewText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function translateReviewPair(title, content) {
    if (!title || !content || title.dataset.pmTranslatedReview === 'true') return;

    const originalTitle = normalizeReviewText(title.textContent);
    const originalContent = normalizeReviewText(content.textContent);
    const translation = REVIEW_TRANSLATIONS.find(
      (item) => normalizeReviewText(item.title) === originalTitle && normalizeReviewText(item.content) === originalContent
    );

    if (!translation) return;

    title.textContent = translation.translatedTitle;
    content.textContent = translation.translatedContent;
    title.dataset.pmTranslatedReview = 'true';
    content.dataset.pmTranslatedReview = 'true';
    title.lang = 'de';
    content.lang = 'de';
    title.title = 'Sinngemäß ins Deutsche übersetzt';
  }

  function polishGermanReviewPair(title, content) {
    if (!title || !content || title.dataset.pmPolishedReview === 'true') return;

    const originalTitle = normalizeReviewText(title.textContent);
    const originalContent = normalizeReviewText(content.textContent);
    const edit = REVIEW_COPY_EDITS.find(
      (item) => normalizeReviewText(item.title) === originalTitle && normalizeReviewText(item.content) === originalContent
    );

    if (!edit) return;

    title.textContent = edit.editedTitle;
    content.textContent = edit.editedContent;
    title.dataset.pmPolishedReview = 'true';
    content.dataset.pmPolishedReview = 'true';
    title.lang = 'de';
    content.lang = 'de';
    title.title = 'Rechtschreibung behutsam korrigiert';
  }

  function translateReviewElements(titleSelector, contentSelector) {
    document.querySelectorAll(titleSelector).forEach((title) => {
      let scope = title.parentElement;

      while (scope && scope !== document.body) {
        const titles = scope.querySelectorAll(titleSelector);
        const contents = scope.querySelectorAll(contentSelector);

        if (titles.length === 1 && contents.length === 1) {
          translateReviewPair(title, contents[0]);
          return;
        }

        scope = scope.parentElement;
      }
    });
  }

  function translateReviews() {
    translateReviewElements('.st_rvws-review-title', '.st_rvws-review-content');
    translateReviewElements('.st_rvws-masonry-title', '.st_rvws-masonry-text');
    translateReviewElements('.st_rvws-review-popup-title', '.st_rvws-review-popup-text');

    document.querySelectorAll('.st_rvws-review-title').forEach((title) => {
      const row = title.closest('.st_rvws-review-row');
      polishGermanReviewPair(title, row?.querySelector('.st_rvws-review-content'));
    });
  }

  function normalizedProductPaths(root, selector) {
    if (!root) return [];

    const currentPath = window.location.pathname.replace(/\/$/, '');
    const paths = Array.from(root.querySelectorAll(selector))
      .map((link) => {
        try {
          return new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
        } catch (_error) {
          return '';
        }
      })
      .filter((path) => path && path !== currentPath);

    return [...new Set(paths)].sort();
  }

  function sameProductSet(first, second) {
    return first.length > 0 && first.length === second.length && first.every((path, index) => path === second[index]);
  }

  function streamlineRecentlyViewed() {
    const crossSell = document.querySelector('.related-products-section');
    const recentWidget = document.querySelector('.ws-widget-section.ws-grid-view');
    const recentSection = recentWidget?.closest('.shopify-section');
    if (!crossSell || !recentSection) return;

    const crossSellProducts = normalizedProductPaths(
      crossSell,
      '.st_related-product-card[href*="/products/"]'
    );
    const recentProducts = normalizedProductPaths(recentSection, 'a[href*="/products/"]');
    if (!crossSellProducts.length || !recentProducts.length) return;

    const isDuplicate = sameProductSet(crossSellProducts, recentProducts);
    recentSection.classList.toggle('pm-recently-viewed--duplicate', isDuplicate);
    recentSection.setAttribute('aria-hidden', isDuplicate ? 'true' : 'false');
    recentSection.dataset.pmRecommendationState = isDuplicate ? 'duplicate-hidden' : 'unique-visible';
  }

  function addLongReviewToggle(content, index) {
    if (content.dataset.pmReviewClampReady === 'true') return;

    content.dataset.pmReviewClampReady = 'true';
    if ((content.textContent || '').trim().length <= LONG_REVIEW_LENGTH) return;

    const contentId = `PmReviewContent-${index}-${Math.random().toString(36).slice(2, 8)}`;
    const button = document.createElement('button');

    content.id = contentId;
    content.classList.add('pm-review-content--collapsed');
    button.type = 'button';
    button.className = 'pm-review-text-toggle';
    button.textContent = 'Mehr lesen';
    button.setAttribute('aria-controls', contentId);
    button.setAttribute('aria-expanded', 'false');

    button.addEventListener('click', () => {
      const willExpand = button.getAttribute('aria-expanded') !== 'true';
      content.classList.toggle('pm-review-content--collapsed', !willExpand);
      content.classList.toggle('pm-review-content--expanded', willExpand);
      button.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
      button.textContent = willExpand ? 'Weniger anzeigen' : 'Mehr lesen';
    });

    content.insertAdjacentElement('afterend', button);
  }

  function createInitialReviewButton(section, list, hiddenCount) {
    let wrapper = section.querySelector('.pm-reviews-initial-toggle-wrap');
    let button = wrapper?.querySelector('.pm-reviews-initial-toggle');

    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'pm-reviews-initial-toggle-wrap';
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'pm-reviews-initial-toggle';
      button.setAttribute('aria-expanded', 'false');
      wrapper.append(button);
      list.insertAdjacentElement('afterend', wrapper);

      button.addEventListener('click', () => {
        section.dataset.pmReviewsExpanded = 'true';
        section.classList.remove('pm-reviews--initially-collapsed');
        section.querySelectorAll('.pm-review-row--initially-hidden').forEach((row) => {
          row.classList.remove('pm-review-row--initially-hidden');
        });
        wrapper.remove();
      });
    }

    if (button) {
      button.textContent = `${hiddenCount} weitere ${hiddenCount === 1 ? 'Bewertung' : 'Bewertungen'} anzeigen`;
    }
  }

  function enhanceReviewPresentation(reviewSection) {
    const mediaContainer = reviewSection.querySelector('.st_rvws-summary-media-container');
    const media = mediaContainer?.querySelector('.st_rvws-summary-media');
    const images = media ? Array.from(media.querySelectorAll('.st_rvws-summary-img')) : [];
    if (!mediaContainer || !media || !images.length) return;

    mediaContainer.classList.add('pm-review-media-gallery');
    mediaContainer.setAttribute('role', 'region');
    mediaContainer.setAttribute('aria-label', 'Kundenfotos aus Bewertungen');
    media.setAttribute('role', 'list');
    images.forEach((image, index) => {
      image.setAttribute('role', 'listitem');
      image.alt = `Kundenfoto aus einer Produktbewertung ${index + 1}`;
      image.loading = 'lazy';
      image.decoding = 'async';
    });
  }

  function streamlineReviews() {
    translateReviews();

    const reviewSection = document.querySelector('.sternify-review-widget-block')?.closest('.shopify-section');
    const reviewList = reviewSection?.querySelector('.st_rvws-reviews-list');
    if (!reviewSection) return;

    reviewSection.id = 'PmProductReviews';
    enhanceReviewPresentation(reviewSection);
    if (!reviewList) return;

    const summaryCount = reviewSection.querySelector('.st_rvws-summary-count');
    const productRatingCount = document.querySelector('.pm-product-rating-summary__text')?.textContent?.match(/\b(\d+)\s+Bewertungen?\b/i)?.[1];
    if (summaryCount && productRatingCount) {
      summaryCount.textContent = `${productRatingCount} Kundenbewertungen`;
    }

    const rows = Array.from(reviewList.querySelectorAll('.st_rvws-review-row'));
    rows.forEach((row, index) => {
      const content = row.querySelector('.st_rvws-review-content');
      if (content) addLongReviewToggle(content, index);
    });

    if (reviewSection.dataset.pmReviewsExpanded === 'true') {
      reviewSection.classList.remove('pm-reviews--initially-collapsed');
      rows.forEach((row) => row.classList.remove('pm-review-row--initially-hidden'));
      reviewSection.querySelector('.pm-reviews-initial-toggle-wrap')?.remove();
      return;
    }

    const hiddenCount = Math.max(rows.length - REVIEW_LIMIT, 0);
    reviewSection.classList.toggle('pm-reviews--initially-collapsed', hiddenCount > 0);
    rows.forEach((row, index) => {
      row.classList.toggle('pm-review-row--initially-hidden', index >= REVIEW_LIMIT);
    });

    if (hiddenCount > 0) {
      createInitialReviewButton(reviewSection, reviewList, hiddenCount);
    } else {
      reviewSection.querySelector('.pm-reviews-initial-toggle-wrap')?.remove();
    }
  }

  function scan() {
    scanQueued = false;
    streamlineReviews();
    streamlineRecentlyViewed();
  }

  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(scan);
  }

  function init() {
    queueScan();

    const observerTarget = document.body;
    const observer = new MutationObserver(queueScan);
    observer.observe(observerTarget, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', queueScan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
